import { Point, Rectangle, Geometry } from "../../drawing";
import { AbstractDrawableItem } from "./AbstractDrawableItem";

export abstract class AbstractPointsItem extends AbstractDrawableItem {
  constructor(typeKey: string) {
    super(typeKey);
  }

  get points(): Point[] {
    return this._points;
  }

  set points(value: Point[]) {
    this._points = value;
    this.geometry = new Geometry(Rectangle.from(value));
  }

  private _points: Point[] = [];

  protected applyMembers(clone: AbstractPointsItem): void {
    super.applyMembers(clone);
    clone.points = this.cloneValue(this.points);
  }
}
